import checkout_config from "./checkout_config";

export default {
    checkout_config,
}